import * as React from 'react';
import {message} from 'antd';
import * as Path from 'path';
export default function UploadButton(props: {
  id: string;
  label?: string;
  loading: boolean;
  accept?: string;
  multiple?: boolean;
  disabled?: boolean;
  maxSize?: number;
  upload: (formData: FormData) => any;
}) {
  function upload() {
    const formData = new FormData(document.getElementById(props.id) as HTMLFormElement);
    const file = formData.get('file') as File;
    console.log(Path.extname(file.name));
    if (file.size >= (props.maxSize || 100) * 1024 * 1024) {
      message.error('超出文件大小限制');
    } else if (!props.accept?.includes(Path.extname(file.name))) {
      message.error('不支持的文件类型');
    } else if (!props.disabled) {
      props.upload(formData);
    }
  }
  return (
    <div id="upload-button">
      <div className="ant-btn file ant-btn-primary">
        {props.loading && <span>上传中</span>}
        {!props.loading && <span>{props.label ? props.label : '选择文件'}</span>}
        {!props.loading && (
          <form id={props.id}>
            <input onChange={() => upload()} type="file" multiple={props.multiple} disabled={props.disabled} name="file" />
          </form>
        )}
      </div>
    </div>
  );
}
